(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mom-discovery-ux"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const updateStickyOffset = () => {
      const header = document.querySelector('.shopify-section-header-sticky, .section-header');
      const height = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--mom-sticky-header-offset', `${height}px`);
    };
    updateStickyOffset();
    window.addEventListener('resize', updateStickyOffset, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mom-product-conversion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bars = document.querySelectorAll('[data-mom-mobile-buybar]');

    bars.forEach((bar) => {
      if (bar.dataset.ready === 'true') return;
      bar.dataset.ready = 'true';

      const stickyButton = bar.querySelector('[data-mom-mobile-cta]');
      const stickyPrice = bar.querySelector('[data-mom-mobile-price]');
      const stickyVariant = bar.querySelector('[data-mom-mobile-variant]');
      const infoContainer = document.querySelector('.product__info-container');
      const primaryButton = infoContainer?.querySelector('.product-form__submit');

      if (!stickyButton || !primaryButton || !infoContainer) return;

      const readSelectedVariant = () => {
        const picker = infoContainer.querySelector('variant-selects, variant-radios');
        if (!picker) return '';

        const values = [];

        picker.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
          if (input.value && input.value !== 'Default Title') values.push(input.value.trim());
        });

        picker.querySelectorAll('select').forEach((select) => {
          const value = select.options[select.selectedIndex]?.textContent?.trim();
          if (value && value !== 'Default Title') values.push(value);
        });

        return [...new Set(values)].join(' / ');
      };

      const readCurrentPrice = () => {
        const salePrice = infoContainer.querySelector('[id^="price-"] .price__sale .price-item--sale');
        if (salePrice?.textContent?.trim()) return salePrice.textContent.trim();

        const regularPrice = infoContainer.querySelector('[id^="price-"] .price__regular .price-item--regular');
        if (regularPrice?.textContent?.trim()) return regularPrice.textContent.trim();

        const fallbackPrice = infoContainer.querySelector('[id^="price-"] .price-item--regular, [id^="price-"] .price-item--sale');
        return fallbackPrice?.textContent?.trim() || '';
      };

      const syncDetails = () => {
        stickyButton.disabled = primaryButton.disabled;

        const primaryText = primaryButton.querySelector('span')?.textContent?.trim();
        if (primaryText) stickyButton.textContent = primaryText;

        const currentPrice = readCurrentPrice();
        if (stickyPrice && currentPrice) stickyPrice.textContent = currentPrice;

        if (stickyVariant) {
          const variantLabel = readSelectedVariant();
          stickyVariant.textContent = variantLabel;
          stickyVariant.hidden = !variantLabel;
        }
      };

      let syncQueued = false;
      const queueSync = () => {
        if (syncQueued) return;
        syncQueued = true;

        requestAnimationFrame(() => {
          syncQueued = false;
          syncDetails();
        });
      };

      stickyButton.addEventListener('click', () => {
        syncDetails();

        if (!primaryButton.disabled) {
          primaryButton.click();
          return;
        }

        const picker = infoContainer.querySelector('variant-selects, variant-radios, .product-form__input');
        (picker || primaryButton).scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      infoContainer.addEventListener('change', () => {
        window.setTimeout(queueSync, 60);
      });

      const observer = new IntersectionObserver(([entry]) => {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      }, { threshold: 0.05 });
      observer.observe(primaryButton);

      const infoObserver = new MutationObserver(queueSync);
      infoObserver.observe(infoContainer, { attributes: true, childList: true, subtree: true, characterData: true });

      syncDetails();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
